import { GRID_FORM_CONFIG_T } from "../../common/FormGenerator"
import { CommentInput } from "../ui-kit/CommentInput"

export type CommentBlockName =
  | "commentText"

type GetCommentConfigParams = {
  onSend?: () => void
  disabled?: boolean
}

export const getCommentTextConfig = ({ onSend, disabled }: GetCommentConfigParams = {}) => [
  [
    {
      id: 1,
      controllerName: "commentText",
      RenderElement: CommentInput,
      renderProps: () => ({
        placeholder: "Введите ваш вопрос…",
        fullWidth: true,
        onSend,
        disabled,
      }),
    },
  ],
]

export const getFormConfig = (blockName: CommentBlockName, params?: GetCommentConfigParams): GRID_FORM_CONFIG_T<any> => {
  if (blockName === "commentText") {
    return getCommentTextConfig(params)
  }
  return []
}
